import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    seoPages : {}
}
const seoSlice = createSlice({
    name : 'seoSlice' ,
    initialState ,
    reducers : {
        getPagesSeo : (state , action) => {
            state.seoPages = action.payload
        }
    }
})
export const {getPagesSeo} = seoSlice.actions
export default seoSlice.reducer